import { LOCATION_NEIGHBORHOOD } from '../../routes';
import customAxios from '../../customAxios';

async function deleteNegiborhood(_id: string) {
  try {
    return (await customAxios.delete(`${LOCATION_NEIGHBORHOOD}/${_id}`)).data;
  } catch (error: any) {
    console.error({LOCATION_AREA: error});
  }
}

export default deleteNegiborhood;
